import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AcbExperienceBadge = ({ seasons, matches, compact = false }) => {
  const { t } = useTranslation();
  const s = Number(seasons) || 0;
  const m = Number(matches) || 0;
  if (s <= 0) return null;

  return (
    <Tooltip
      arrow
      title={t('playerProfile.acb.combinedTooltip', {
        seasons: s,
        matches: m,
        count: s
      })}
    >
      <Chip
        label="ACB"
        size="small"
        sx={{
          backgroundColor: '#e0e0e0',
          color: '#000',
          fontWeight: 'bold',
          height: compact ? 18 : 22,
          fontSize: compact ? '0.65rem' : '0.75rem',
          '& .MuiChip-label': { px: compact ? 0.5 : 0.75 }
        }}
      />
    </Tooltip>
  );
};

export default AcbExperienceBadge;
